import clsx from 'clsx';

export type CreateMode = 'generate' | 'upload';

const modes: { value: CreateMode; label: string }[] = [
  { value: 'generate', label: 'Generate new' },
  { value: 'upload', label: 'Upload' },
];

interface CreateModeToggleProps {
  mode: CreateMode;
  onChange: (mode: CreateMode) => void;
}

export function CreateModeToggle({ mode, onChange }: CreateModeToggleProps) {
  return (
    <div className="flex gap-1 mb-6 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg w-fit">
      {modes.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          className={clsx(
            'px-4 py-1.5 rounded-md text-sm font-medium transition-colors',
            mode === value
              ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
              : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
